/*
 * Request Product Access submission
 *
 **/

custom.requestAccessSubmission = (function () {
  const requestAccessClass = 'js-request-product-access';
  const addSampleRackClass = 'js-add-sample-rack';
  const accessMessageArea = 'js-request-access-message';

  function requestProductAccess(e = null) {
    e.preventDefault();
    const $button = $(this);
    const customerEmail = $button.data('email');
    const requestBrand = $button.data('brand') ? $button.data('brand') : '';
    const customerID = $button.data('id') ? $button.data('id') : '';
    const sparsID = $button.data('spars-id') ? $button.data('spars-id') : '';
    const company = $button.data('company') ? $button.data('company') : '';
    const productName = $button.data('product') ? $button.data('product') : '';
    const name = $button.data('name') ? $button.data('name') : company;
    const hutk = custom.utils.getCookie('hubspotutk');
    const postForm = $button.data('form');
    $button
      .addClass('js-working')
      .addClass('js-loading')
      .html(
        "Sending<span class='ellipsis'><span>.</span><span>.</span><span>.</span></span>",
      );
    if (
      customerEmail &&
      requestBrand &&
      customerID &&
      sparsID &&
      productName &&
      postForm
    ) {
      const handelizedBrand = requestBrand
        .toLowerCase()
        .replace(/&nbsp;/g, '-')
        .replace(/[^a-z0-9]+/g, '')
        .replace(/-$/, '')
        .replace(/^-/, '');
      const requestedQuery = `${handelizedBrand}${customerID}`;
      const sendData = {
        submittedAt: new Date().getTime(),
        fields: [
          {
            objectTypeId: '0-1', //contact
            name: 'shopify_id',
            value: customerID,
          },
          {
            objectTypeId: '0-1', //contact
            name: 'loloi_account_number',
            value: sparsID,
          },
          //customer_auth_class: authClass - wasn't in hubspot
          {
            objectTypeId: '0-1', //contact
            name: 'firstname',
            value: $button.data('firstname') ? $button.data('firstname') : name,
          },
          {
            objectTypeId: '0-1', //contact
            name: 'lastname',
            value: $button.data('lastname') ? $button.data('lastname') : '',
          },
          {
            objectTypeId: '0-1', //contact
            name: 'company',
            value: company,
          },
          {
            objectTypeId: '0-1', //contact
            name: 'form_request_product_name',
            value: productName,
          },
          {
            objectTypeId: '0-1', //contact
            name: 'form_request_brand',
            value: requestBrand,
          },
          {
            objectTypeId: '0-1', //contact
            name: 'email',
            value: customerEmail,
          },
          {
            objectTypeId: '0-1', //contact
            name: 'requested_tag',
            value: requestedQuery,
          },
        ],
        context: {
          ...(hutk ? { hutk: hutk } : {}),
          pageUri: window.location.host + window.location.pathname,
          pageName: document.title,
        },
      };
      // send form
      let brandName = requestBrand;
      if (
        window.LoloiConfig &&
        window.LoloiConfig.xloloi_collab &&
        window.LoloiConfig.xloloi_collab.includes(brandName)
      ) {
        brandName += ' × Loloi';
      }
      window.MUAPP.sendCRMForm(postForm, sendData).then(
        (data) => {
          requestAccessMessage(
            $button,
            `Thanks, we'll evaluate your request to purchase ${brandName} products and will be in touch.`,
          );
        },
        (err) => {
          requestAccessError(
            $button,
            `Unable to submit access request. Please contact <a href="mailto:info@loloirugs.com">info@loloirugs.com</a> to request access to ${brandName}.`,
          );
        },
      );
    } else {
      requestAccessError(
        $button,
        `Your customer email seems to be missing. Please contact <a href="mailto:info@loloirugs.com">info@loloirugs.com</a> to request access to ${requestBrand}.`,
      );
    }
  }

  function requestAccessMessage($el = null, message = null) {
    if (!message || !$el) return;
    const target = $el.data('message-target');
    $el.parent().addClass('hidden');
    if (target === 'pdpCTAmessages') $el.parent().parent().addClass('hidden');
    $(`#${target}`).find(`.${accessMessageArea}`).html(message);
    $(`#${target}`).removeClass('hidden');
    setTimeout(function () {
      $el.text('Request Access');
      $(`#${target}`).addClass('hidden');
      $el.parent().removeClass('hidden');
      if (target === 'pdpCTAmessages')
        $el.parent().parent().removeClass('hidden');
    }, 5000);
  }

  function sampleRequestMessage(e = null) {
    const $el = $(this);
    const target = $el.data('message-target');
    setTimeout(function () {
      $el.addClass('hidden');
      $(`#${target}`)
        .find(`.${accessMessageArea}`)
        .html(
          'Loloi will follow up after your purchase so you may select your 70 free samples.',
        );
      $(`#${target}`).removeClass('hidden');
      setTimeout(function () {
        $(`#${target}`).addClass('hidden');
        $el.removeClass('hidden');
      }, 5000);
    }, 150);
  }

  function requestAccessError($el = null, message = null) {
    if (!message || !$el) return;
    $(`.${accessMessageArea}`).addClass('text-red');
    requestAccessMessage($el, message);
  }

  function init() {
    $('.template-product').on(
      'click',
      `.${requestAccessClass}`,
      requestProductAccess,
    );
    $('.quick-view-drawer').on(
      'click',
      `.${requestAccessClass}`,
      requestProductAccess,
    );
    $('.template-product').on(
      'click',
      `.${addSampleRackClass}`,
      sampleRequestMessage,
    );
    $('.quick-view-drawer').on(
      'click',
      `.${addSampleRackClass}`,
      sampleRequestMessage,
    );
  }

  return {
    init: init,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/request-access-submission.js